import { createClient } from "@supabase/supabase-js";

// Fail closed, deliberately, rather than silently defaulting to any Supabase
// project. A hardcoded fallback here previously defaulted to production
// whenever the env var was merely undefined — meaning a missing/misconfigured
// build (local, CI, or a production build with a broken env file) would
// silently talk to whichever project happened to be hardcoded, instead of
// refusing to start. Which project loads for a given build is controlled
// entirely by which env file Vite picks up for that build mode (`.env` for
// dev, `.env.production` for `vite build`) — see CLAUDE.md's Environment
// Architecture section.
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  throw new Error(
    "Missing VITE_SUPABASE_URL / VITE_SUPABASE_PUBLISHABLE_KEY. This app never " +
      "falls back to a default Supabase project — check that the correct env " +
      "file is present for this build mode (.env for local dev, .env.production " +
      "for a production build) and that it defines both variables.",
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
});
